import { lazy } from 'react'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'
const RootPage = lazy(() => import('modules/incentives/pages/RootPage'))
const IncentivesList = lazy(() => import('modules/incentives/pages/IncentivesList'))

export const incentivesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.compensations.incentives.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          element: <IncentivesList />,
        },
      ],
    },
  ]
}
